import { FullQALogo } from '../Logos'
import { ModuleSelect } from './ModuleSelect'
import { UserPill } from './UserPill'
import { LogoutButton } from './LogoutButton'

import styles from './TopBar.module.scss'

/**
 * @param {{ title?: string }} props
 */
export function TopBar({ title }) {
  return (
    <div id='topbar' className={styles['topbar']}>
      <div>
        <span className={styles['logo']}>
          <FullQALogo variant='light' />
        </span>
        <h1>{title || 'PEP Quality Evaluation Module'}</h1>
        <div className={styles['actions-container']}>
          <ModuleSelect />
          <UserPill />
          <LogoutButton />
        </div>
      </div>
    </div>
  )
}
